export const GAME_DATA =
[
    {
        category: "Broadway Musicals",
        words: ["Into the Woods", "Hamilton", "Wicked", "Book of Mormon"],
        difficulty: 1,
    },
    {
        category: "Buffy the Vampire Slayer Episodes",
        words: ["Something Blue", "Prophecy Girl", "Triangle", "Once More With Feeling"],
        difficulty: 2,
    },
    {
        category: "Important People in Our House",
        words: ["Molly", "Secret", "Buffy", "Spike"],
        difficulty: 3,
    },
    {
        category: "Proposal",
        words: ["Exquisite", "Ennui", "Pickles", "Timbuktu"],
        displayWords: ["Will", "You", "Marry", "Me?"],
        difficulty: 4,
    },
];
